import React from 'react';
import { PropTypes } from "prop-types";

const FormInput2 = ({
    type,
    label,
    field,
    form,
    onChange,
    onBlur,
    name,
    onFocus,
    placeholder
}) => {

    return (
        <div>
            <div className="form2-input-container">
                <label className="form2-label">{label}</label>
                <input
                    type={type}
                    placeholder={placeholder}
                    onFocus={onFocus}
                    onChange={(field && field.onChange) || onChange}
                    onBlur={(field && field.onBlur) || onBlur}
                    value={(field && field.value) || ''}
                    name={(field && field.name) || name}
                    className="form2-input"
                />
            </div>
            {form && form.touched[field.name] && form && form.errors[field.name] && (
                <small className="errors2">{form.errors[field.name]}</small>
            )}
        </div>
    )
}

FormInput2.propTypes = {
    type: PropTypes.string,
    placeholder: PropTypes.string,
    field: PropTypes.object,
    form: PropTypes.object,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    name: PropTypes.string,
    onFocus: PropTypes.func,
    value: PropTypes.string,
    label: PropTypes.string
}


export default FormInput2;
